
import {
	Card,
	CardBody,
	Icon,
	Button,
} from '@wordpress/components';

const NoBlockTheme = () => {
	return <>
		<Card>
			<CardBody>
				<div className="gutenify--template-kit-browser--no-theme">
					<Icon icon="warning" />
					<h3>Current Theme is not supported for Template Kit. Please download supported theme.</h3>
					<Button href="#" isPrimary><Icon icon="welcome-view-site" /> &nbsp; Browse Supported Themes </Button>
				</div>
			</CardBody>
		</Card>
	</>;
};
export default NoBlockTheme;
